<template>
	<Transition name="changelog-banner">
		<div
			v-if="changelogStore.showBanner && latest"
			class="changelog-banner fixed bg-white bottom-4 left-1/2 z-[2000] w-[min(640px,calc(100vw-2rem))] -translate-x-1/2 rounded-xl border border-primary/30 bg-surface-0 shadow-lg dark:bg-surface-900"
			role="status"
			aria-live="polite"
		>
			<div class="flex gap-3 p-4">
				<div
					class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/15 text-primary"
				>
					<i class="pi pi-sparkles text-lg"></i>
				</div>
				<div class="min-w-0 flex-1">
					<div class="flex flex-wrap items-center gap-2">
						<span class="font-semibold text-surface-900 dark:text-surface-0">{{ latest.title }}</span>
						<Tag v-if="latest.version" severity="info" :value="`v${latest.version}`" class="text-xs" />
						<span v-if="latest.published_at" class="text-xs text-surface-500">
							{{ changelogStore.formatDate(latest.published_at) }}
						</span>
					</div>
					<p class="mt-1 line-clamp-2 text-sm text-surface-600 dark:text-surface-300" v-html="previewBody"></p>
				</div>
				<Button
					icon="pi pi-times"
					text
					rounded
					severity="secondary"
					class="shrink-0"
					:aria-label="t('changelog.dismiss')"
					@click="onDismiss"
				/>
			</div>
			<div class="flex justify-end gap-2 border-t border-surface-200 px-4 py-2 dark:border-surface-700">
				<Button
					:label="t('changelog.view_all')"
					severity="secondary"
					text
					size="small"
					@click="goToChangelog"
				/>
				<Button
					:label="t('changelog.got_it')"
					severity="primary"
					size="small"
					@click="onDismiss"
				/>
			</div>
		</div>
	</Transition>
</template>

<script lang="ts" setup>
import { computed } from "vue"
import { useRouter } from "vue-router"
import Button from "primevue/button"
import Tag from "primevue/tag"
import { useChangelogStore } from "@/stores/apps/changelog"
import { useStoreI18n } from "@/composables/useStoreI18n"

const { t } = useStoreI18n()
const router = useRouter()
const changelogStore = useChangelogStore()

const latest = computed(() => changelogStore.latestUnread)

const previewBody = computed(() => {
	const body = latest.value?.body || ""
	const plain = body.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim()
	return plain.length > 180 ? `${plain.slice(0, 180)}…` : plain
})

async function onDismiss() {
	if (latest.value) {
		await changelogStore.markRead(latest.value.id)
	}
	changelogStore.dismissBanner()
}

function goToChangelog() {
	changelogStore.dismissBanner()
	router.push({ name: "Changelog" })
}
</script>

<style scoped>
.changelog-banner-enter-active,
.changelog-banner-leave-active {
	transition: opacity 0.25s ease, transform 0.25s ease;
}
.changelog-banner-enter-from,
.changelog-banner-leave-to {
	opacity: 0;
	transform: translate(-50%, 12px);
}
</style>
